import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import styled from 'styled-components';
import { Typography } from '@material-ui/core';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { visitHeaderID } from '@mummssoftware/utils/constants'; // interface blah extends JSX.IntrinsicClassAttributes

const Header = styled.div.withConfig({
  displayName: "SectionHeader__Header",
  componentId: "sc-19fz2vr-0"
})(["display:flex;background:", ";color:", ";width:fill-available;align-items:center;padding:0 6px 1px;justify-content:space-between;height:31px;"], props => props.theme.palette.error.light, props => props.theme.palette.common.white);
const ActionDiv = styled.div.withConfig({
  displayName: "SectionHeader__ActionDiv",
  componentId: "sc-19fz2vr-1"
})(["align-self:flex-end;margin-right:-3px;margin-top:0px;"]);
const HeaderTitle = withStyles(() => createStyles({
  root: {
    position: 'relative',
    padding: '0 8px',
    lineHeight: 'normal',
    height: 'auto',
    textTransform: 'uppercase',
    fontSize: 'clamp(1rem, 3.5vw, 1.5rem)'
  }
}))(Typography);
export const SectionHeader = ({
  id,
  title,
  nav,
  minimized,
  TypographyProps,
  style
}) => /*#__PURE__*/React.createElement(Header, {
  id: visitHeaderID,
  style: style
}, /*#__PURE__*/React.createElement(HeaderTitle, _extends({
  id: id,
  variant: minimized ? 'subtitle1' : 'h6' // color={minimized ? undefined : 'primary'}

}, TypographyProps), title), /*#__PURE__*/React.createElement(ActionDiv, null, nav));